export default __webpack_public_path__ + "static/media/filters-icon.4a35fdaf.svg";